export enum ImportExistingCrmIdType {
    Undefined = 0,
    Ignore = 1,
    Update = 2
}

export enum ImportExistingExternalIdType {
    Undefined = 0,
    Ignore = 1,
    Update = 2
}
